/*
 * Automatically generated by SVGR from assets/icons/*.svg.
 * Do not edit this file or add other components to this directory.
 */
import type { SVGProps } from 'react'
export function CopyIcon(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='1em'
      height='1em'
      fill='none'
      viewBox='0 0 25 25'
      {...props}
    >
      <path
        fill='#232B3A'
        d='M5.84 22.988q-.825 0-1.412-.587a1.93 1.93 0 0 1-.587-1.413v-14h2v14h11v2zm4-4q-.825 0-1.411-.587a1.93 1.93 0 0 1-.588-1.413v-12q0-.824.588-1.413a1.93 1.93 0 0 1 1.412-.587h9q.824 0 1.413.587.587.588.587 1.413v12q0 .825-.587 1.413a1.93 1.93 0 0 1-1.413.587zm0-2h9v-12h-9z'
      />
    </svg>
  )
}
